<template>
  <Container class="container-sm-none">
      <Card class="card-shadow mt-15 mt-md-0">
        <div class="width-lg">
          <div class="pl-10 pl-md-0 pr-10 pr-md-0">
            <IconEmail />
            <p class="heading-2 heading-md-1 weight-medium mt-20">
              We're sorry, but your application could not be signed.
            </p>
            <p class="body-3 body-md-1 text-left weight-regular mt-10">
              We have e-mailed you a confirmation along with instructions and
              a link to download
              your completed application form.
            </p>
            <DownloadApplication v-for="(person, index) in model.insuredPersons.array_hd7ov6$_0"
                                 :path="model.saveResponse[index].docs.filter(doc => doc.name === 'uzp-prihlaska.pdf')[0].path"
                                 :variableSymbol="model.saveResponse[index].cislo"
                                 :person="person"
                                 :key="index"/>
            <p class="heading-3 mt-20">
              What are the next steps?
            </p>
            <Card class="card-border-gray-300 p-10 mt-10 b-rounded-12">
                <div class="flex gap-6 w-full">
                    <CircleNumber :value="1" />
                    <p class="body-3 mt-2 mb-0 text-left">
                      Download, print and sign the completed application form.
                    </p>
                </div>

                <div>
                    <div class="flex gap-6 mt-10 w-full">
                        <CircleNumber :value="2" />
                        <p class="body-3 mt-2 mb-0 text-left">
                          Submit the signed application form along with a copy of the identity document
                          <a class="color-primary" href="https://www.union.sk/union-kontakty/pobocky/" target="_blank">
                            to any Union contact point,
                          </a>
                          or send it by post to:
                          <i class="flex">Union zdravotná poisťovňa, a. s.</i>
                          <i class="flex">Karadžičova 10</i>
                          <i class="flex">814 53 Bratislava</i>
                        </p>
                    </div>
                    <InfoBox class="mt-10 ib-warning" :icon="require('@/assets/svg/alert-icon.svg')">
                        <p class="m-0 body-3 weight-regular">
                          In the event of changing health insurance providers, the signed application form must be sent no later than 30 September.
                        </p>
                    </InfoBox>
                </div>

                <div class="flex gap-6 mt-10 w-full">
                    <CircleNumber :value="3" />
                    <p class="body-3 mt-2 mb-0 text-left">
                      Please wait for your new health insurance card to be issued, and don't forget to check out the
                        <a class="color-primary" href="https://www.union.sk/vyhody-pre-poistencov/" target="_blank">
                          wide range of benefits we offer.
                        </a>
                    </p>
                </div>
            </Card>
            <h3 class="mt-20">
              Thank you for being with us.
            </h3>
            <Rating :model="model"/>
            <div class="width-md mt-20">
                <Button v-if="showReturnHomeButton" @click="redirectToMainPage" class="btn-primary w-full" :icon-right="require('@/assets/svg/icon-right-white.svg')">
                  Go to Main Page
                </Button>
            </div>
          </div>
        </div>
      </Card>
  </Container>
</template>

<script>
import Card from '@/components/Card/Card.vue';
import Container from '@/components/Container/Container.vue';
import IconEmail from '@/components/Icons/IconEmail.vue';
import CircleNumber from '@/components/CircleNumber/CircleNumber.vue';
import Button from '@/components/Button/Button.vue';
import InfoBox from '@/components/InfoBox/InfoBox.vue';
import GA from '@/mixins/GA';
import { setHashChannelParams } from '@/utils/urlParams';
import url from '@/mixins/url';
import Rating from '@/components/Rating/Rating.vue';
import DownloadApplication from '@/components/DownloadApplication/DownloadApplication.vue';

export default {
  name: 'ThankYouFail',
  components: {
    DownloadApplication,
    Rating,
    Container,
    Card,
    IconEmail,
    CircleNumber,
    Button,
    InfoBox,
  },
  mixins: [GA, url],
  props: {
    model: { required: true, type: Object },
  },
  methods: {
    redirectToMainPage() {
      const { hash, channel } = this.$route.query;
      const otherParams = setHashChannelParams(hash, channel);
      window.location.replace(`${window.location.origin + window.location.pathname}#landing-page${otherParams}`);
      window.location.reload();
    },
  },
  created() {
    this.$router.maxStep = 23;
    this.model.step = 23;
    if (this.model.lastStep < 23) this.model.lastStep = 23;
  },
  mounted() {
    this.funnelError('save', `${this.$store.state.saveError.response.status}-${this.$store.state.saveError.response.statusText}`, this.$store.state.saveError.response.data);
  },
};
</script>
